import React, { useEffect, useState } from "react";
// import Sidebar from "../../../layouts/sidebar";
import Sidebar from "../../layouts/sidebar";
import Headers from "../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col, Modal } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
// import useAxiosFile from "../../../actions/useaxios";
import useAxiosFile from "../../actions/useaxios";
// import config from "../../../actions/config";
import config from "../../actions/config";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
// import Exportcsv from "./Exportcsv";
import Exportcsv from "../loginpages/Managementpages/Exportcsv";
// import { DecryptData, EncryptData, isEmpty } from "../../../actions/common";
import {
  DateTimeForm,
  DecryptData,
  EncryptData,
  isEmpty,
} from "../../actions/common";
import { toast } from "react-toastify";

function VendorFinance() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [shopModal, setShopModal] = useState(false);

  const { toggle } = useSelector((state) => state.admin_panel.User);
  const [opacity, setOpacity] = useState("false");

  const navigate = useNavigate();

  const axiosFile = useAxiosFile();

  const [seller, setseller] = useState();
  const [exportdata, setExportdata] = useState([]);

  const [shoplist, SetShopList] = useState([]);

  const [filterdatas, SetFilterDatas] = useState({});

  const [ payupdate, SetPayupdate ] = useState({ message: '', orderdata: {} });
  const [ Error, SetError ] = useState({})

  const shoppayoptions = [
    {
      label: 'Paid Completely',
      value: '100',
    },
    {
      label: 'Paid Partially',
      value: '50',
    },
    {
      label: 'Not-Paid',
      value: '0',
    },
  ]

  useEffect(() => {
    GetOrders();
  }, []);

  const GetOrders = async (filter) => {
    filter = { ...filterdatas, ...(filter ? filter : {}) };
    if (filter) {
      filter.startdate = filter.startdate
        ? filter.startdate.getTime()
        : undefined;
      filter.enddate = filter.enddate ? filter.enddate.getTime() : undefined;
    }

    let senddata = {
      action: "get",
      filter: filter,
      from: "admin",
    };
    var resp = await axiosFile.GetOrderVendorList(senddata);
    console.log("dasdasdsadsa", resp);
    if (resp?.data?.length > 0) {
      // (resp?.data||[])?.map((val, idx) => {

      //   val.hash = <img className='tab_dummyimg' src={val.BrandImage ? `${config.IMG_URL}/shop/${val?.BrandImage}` : require('../../../assests/images/dummyimg.png')} />
      //   val.action = <div class="dropdown table_viewdropdown">
      //     <button class="btn table_viewdrop dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
      //       <i class="fa-solid fa-ellipsis" />
      //     </button>
      //     <ul class="dropdown-menu">
      //       <li><Link class="dropdown-item table_viewborbot" to={`/managementvendorsview/?Id=${String(EncryptData((val?.SellerId)))}`}>View</Link></li>
      //       {/* <li><a class="dropdown-item table_viewborbot">Edit</a></li>
      //       <li><a class="dropdown-item">Delete</a></li> */}
      //     </ul>
      //   </div>

      // })
      var ddd =
        resp.length > 0
          ? (resp || [])?.map(({ _id, _v, ...rest }) => {
              return rest;
            })
          : [];
      setExportdata(ddd);
    }
    SetShopList(
      Array.isArray(resp?.data?.shoplist) ? resp?.data?.shoplist : []
    );
    setseller(resp?.data?.orderlist);
  };

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) {},
    onSizePerPageChange: function (page, sizePerPage) {},
  });

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
        ? "#F5F6F7"
        : isHovered
        ? "red"
        : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
          ? "#a71d24"
          : isFocused
          ? "#a71d24"
          : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
          ? "#fff"
          : isFocused
          ? "#fff"
          : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const handleShopModalClose = () => {
    setShopModal(false);
    SetPayupdate({message:'',orderdata:{}});
  };

  const columns = [
    {
      dataField: "Time",
      text: "Order Completed Timing",
      sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p style={{ fontSize: "13px", fontWeight: "700" }}>
            {cell?.completed
              ? DateTimeForm(new Date(cell?.completed))
              : "No Date"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Shop Id",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          {console.log("cellcellcell", cell)}
          <p className="gry_txt">{cell?._id}</p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Shop Name",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">{cell?.BrandName}</p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Mobile Number",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.Mobile ? cell?.Mobile : "Mobile Number Not-Given"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Account Number",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.BankDetails?.AccountNumber
              ? cell?.BankDetails?.AccountNumber
              : "Account Number not Provided"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Routing Number",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.BankDetails?.RoutingNumber
              ? cell?.BankDetails?.RoutingNumber
              : "Routing Number not Provided"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Account Holder Name",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.BankDetails?.AccountHolderName
              ? cell?.BankDetails?.AccountHolderName
              : "Name not Provided"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Account Type",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.BankDetails?.AccountType
              ? cell?.BankDetails?.AccountType
              : "No Account Type Given"}
          </p>
        </>
      ),
    },
    {
      dataField: "ShopId",
      text: "Bank Name",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="dark_gry">
            {cell?.BankDetails?.BankName
              ? cell?.BankDetails?.BankName
              : "No Bank Name Given"}
          </p>
        </>
      ),
    },
    {
      dataField: "OrderNumber",
      text: "Order Id",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="gry_txt">{cell}</p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Order Value",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="gry_txt">
            {row?.ShopId?.CurrencySymbol} {cell?.PayAmount}
          </p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Product Value",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="gry_txt">
            {row?.ShopId?.CurrencySymbol} {cell?.CartValue}
          </p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Tax",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="blue_txt">
            {row?.ShopId?.CurrencySymbol} {Number(cell?.Taxes)?.toFixed(2)}
          </p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Driver Tips",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="gry_txt">
            {row?.ShopId?.CurrencySymbol} {Number(cell?.DriverTipsInValue).toFixed(2)}
          </p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Seller Tips",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="gry_txt">
            {row?.ShopId?.CurrencySymbol} {Number(cell?.SellerTipsInValue).toFixed(2)}
          </p>
        </>
      ),
    },
    {
      dataField: "Price",
      text: "Delivery Charge",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <p className="blue_txt">
            {row?.ShopId?.CurrencySymbol} {Number(cell?.SellerTipsInValue).toFixed(2)}
          </p>
        </>
      ),
    },

    {
      dataField: "ShopPay",
      text: "Payment Status",
      // sort: true,
      formatter: (cell, row, rowindex) => (
        <>
          <Select
            isSearchable={false}
            options={shoppayoptions}
            menuPortalTarget={document.body} 
            value={shoppayoptions?.find((test)=>cell==test.value)}
            onChange={(e)=>OrderUpdate(row,e)}
          />
        </>
      ),
    },

    {
      dataField: "ShopPay",
      text: "Paid To Shop",
      // sort: true,
      formatter: (cell, row, rowindex) => (

        <Row className="mx-auto">

          <Col xs={10}> {cell ? (
            row?.ShopPaymsg ? (
              row?.ShopPaymsg
            ) : (
              "No Comments"
            )
          ) : "No Comments"
          }</Col>
          <Col xs={2} className="ps-0 d-flex justify-content-end">
            {" "}
            <i
              class="fa-solid fa-pencil curs_poin"
              aria-hidden="true"
              // onClick={() => OrderUpdate(row)}
              onClick={() => {setShopModal(true);SetPayupdate({orderdata:row,message:(row?.ShopPaymsg?row?.ShopPaymsg:"")})}}
            ></i>
          </Col>
        </Row>
      ),
    },
  ];

  const data = [
    {
      hash: (
        // <img
        //   className="tab_dummyimg"
        //   src={require("../../../assests/images/dummyimg.png")}
        // />
        <img
          className="tab_dummyimg"
          src={require("../../assests/images/dummyimg.png")}
          alt="dummyimg"

        />
      ),
      vendorname: "John Doe",
      location: "354 Allen Ave, Pasadena, CA 91106, USA",
      category: "Resturant, Italian",
      status: <button className="table_grnavtivebtn">Available</button>,

      action: (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item table_viewborbot"
                href="/managementvendorsview"
              >
                View
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot drpdw_redtxt">
                Inactive
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot">Order Aceepting Off</a>
            </li>
            <li>
              <a class="dropdown-item">Settlement</a>
            </li>
          </ul>
        </div>
      ),
    },
    {
      hash: (
        <img
          className="tab_dummyimg"
          src={require("../../assests/images/dummyimg.png")}
          alt="dummyimg"

        />
      ),
      vendorname: "John Doe",
      location: "354 Allen Ave, Pasadena, CA 91106, USA",
      category: "Resturant, Italian",
      status: <button className="table_redinactbtn">Not Available</button>,
      action: (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item table_viewborbot"
                href="/managementusersview"
              >
                View
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot drpdw_greentxt">
                Active
              </a>
            </li>
            <li>
              <a class="dropdown-item">Settlement</a>
            </li>
          </ul>
        </div>
      ),
    },

    {
      hash: (
        <img
          className="tab_dummyimg"
          src={require("../../assests/images/dummyimg.png")}
          alt="dummyimg"

        />
      ),
      vendorname: "John Doe",
      vendorId: "#1562",
      location: "354 Allen Ave, Pasadena, CA 91106, USA",
      category: "Resturant, Italian",
      status: (
        <button className="table_sandalactbtn">Waiting for approval</button>
      ),
      action: (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item table_viewborbot"
                href="/managementusersview"
              >
                View
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot drpdw_greentxt">
                Active
              </a>
            </li>
            <li>
              <a class="dropdown-item drpdw_redtxt">Inactive</a>
            </li>
          </ul>
        </div>
      ),
    },

    {
      hash: (
        <img
          className="tab_dummyimg"
          src={require("../../assests/images/dummyimg.png")}
          alt="dummyimg"

        />
      ),
      vendorname: "John Doe",
      vendorId: "#1562",
      location: "354 Allen Ave, Pasadena, CA 91106, USA",
      category: "Resturant, Italian",
      status: <button className="table_grnavtivebtn">Active</button>,
      action: (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item table_viewborbot"
                href="/managementvendorsview"
              >
                View
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot drpdw_redtxt">
                Inactive
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot">Order Aceepting Off</a>
            </li>
            <li>
              <a class="dropdown-item">Settlement</a>
            </li>
          </ul>
        </div>
      ),
    },
    {
      hash: (
        <img
          className="tab_dummyimg"
          src={require("../../assests/images/dummyimg.png")}
          alt="dummyimg"

        />
      ),
      vendorname: "John Doe",
      vendorId: "#1562",
      location: "354 Allen Ave, Pasadena, CA 91106, USA",
      category: "Resturant, Italian",
      status: <button className="table_grnavtivebtn">Active</button>,
      action: (
        <div class="dropdown table_viewdropdown">
          <button
            class="btn table_viewdrop dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="fa-solid fa-ellipsis" />
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                class="dropdown-item table_viewborbot"
                href="/managementvendorsview"
              >
                View
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot drpdw_redtxt">
                Inactive
              </a>
            </li>
            <li>
              <a class="dropdown-item table_viewborbot">Order Accepting Off</a>
            </li>
            <li>
              <a class="dropdown-item">Settlement</a>
            </li>
          </ul>
        </div>
      ),
    },
  ];
  // var header=csvData.map((item)=>
  //     [JSON.stringify(item)]
  //     )

  // const csvReport = {
  //     data: csvData,
  //     filename: fileName
  //   };

  const OrderUpdate = async(order,e) => {
    if(isEmpty(order)){
      if(isEmpty(payupdate?.message)){
        SetError({message:"Enter Message"})
        return false
      }
    }
    const id = toast.loading("Updating...")
    let senddata = {
      action: order ? 'edit' : 'editcomment',
      id: order?._id ? order?._id : payupdate?.orderdata?._id,
      msg: order?._id ? undefined : payupdate?.message,
      status: e?.value,
    }
    console.log('senddatasenddatasenddata',senddata,payupdate)
    let resp = await axiosFile.GetOrderVendorList(senddata);
    console.log('editeditedit',resp)
    if(resp?.status){
      toast.update(id,{render:resp.msg,type:'success',isLoading:false,autoClose:1000});
      handleShopModalClose();
      SetPayupdate({message:'',orderdata:{}});
      GetOrders();
    }
    else{
      toast.update(id,{render:resp.msg,type:'error',isLoading:false,autoClose:1000});
    }

  }

  const OnChange = async (e, from) => {
    console.log("khdkjddada", e, from);
    if (from == "shop") {
      SetFilterDatas({ ...filterdatas, [from]: e?.value });
      GetOrders({ [from]: e?.value });
    } else if (from.includes("date")) {
      SetFilterDatas({ ...filterdatas, [from]: e?._d });
      setOpacity("true");
      GetOrders({ [from]: e?._d });
    }
    else if(from=='ordernumber'){
      SetFilterDatas({ ...filterdatas,[from]: String(e?.target?.value) });
      GetOrders({[from]: String(e?.target?.value)});
    }
  }

  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Headers />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "content-sec-inner right_widthset content_without_sidebar"
                        : "content-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="content-wrapper">
                      <div class="row">
                        <div className="col-12 col-xl-3  d-flex align-items-start align-items-xl-center ">
                          <p className="page_title mb-0">Daily Report</p>
                        </div>
                        <div className="col-12 col-xl-9 mt-sm-4 mt-xl-0  d-flex flex-column flex-md-row align-items-end justify-content-md-end">
                          {" "}
                          <Row className="adm_inpt_wrp align-items-center me-1 me-md-3 my-3 my-sm-0 mb-sm-3 mb-md-0">
                            <Col xs={11}>
                              <input type="text" placeholder="search order-id" onChange={(e)=>OnChange(e,'ordernumber')}/>
                            </Col>
                            <Col
                              xs={1}
                              className="ps-0 d-flex justify-content-end"
                            >
                              <i class="fa fa-search"></i>
                            </Col>
                          </Row>
                          <div className="rightside mt-0 justify-content-end">
                            {/* <button
                              type="button"
                              className="blue_btn add_deliveryprsn"
                              onClick={() => navigate("/addseller")}
                            >
                              Add Locations
                            </button> */}
                            {/* <div class="search-input">
                              <input placeholder="Search" />
                              <span class="fa fa-search"></span>
                            </div> */}
                            {/* <input
                              className="mdv_cmninput"
                              type="text"
                              id="FirstName"
                              placeholder="John"
                            /> */}

                            <div className="rightside_select mt-0">
                              <Select
                                options={shoplist}
                                value={shoplist?.find(
                                  (val) => val?.value == filterdatas?.shop
                                )}
                                styles={stylesgraybg}
                                onChange={(e) => OnChange(e, "shop")}
                                className="border_blue_select"
                                classNamePrefix="react-select"
                                placeholder="Shops"
                              />
                            </div>

                            <div className="order_calendar_div">
                              <p
                                className={
                                  opacity == "true" ? "hiding_caltxt" : ""
                                }
                              >
                                Start Date
                              </p>
                              <img
                                className="order_calendar_ic"
                                src={require("../../assests/images/calendar.png")}
                                alt="calendar"

                              />
                              <Datetime
                                onChange={(e) => {
                                  OnChange(e, "startdate");
                                }}
                                value={filterdatas?.startdate}
                                className="order_datepick"
                              />
                            </div>

                            <div className="order_calendar_div">
                              <p
                                className={
                                  opacity == "true" ? "hiding_caltxt" : ""
                                }
                              >
                                End Date
                              </p>
                              <img
                                className="order_calendar_ic"
                                src={require("../../assests/images/calendar.png")}
                                alt="calendar"

                              />
                              <Datetime
                                onChange={(e) => {
                                  OnChange(e, "enddate");
                                }}
                                value={filterdatas?.enddate}
                                className="order_datepick"
                              />
                            </div>

                            {/* {exportdata && (
                              <Exportcsv
                                csvData={exportdata}
                                fileName={"users"}
                              />
                            )} */}

                            {/* <CSVLink
                              className="downloadbtn"
                              filename="my-file.csv"
                              data={csvData}
                            >
                              Export to CSV
                            </CSVLink> */}
                          </div>
                        </div>
                      </div>
                      <div className="row mx-auto">
                        {console.log("ldjkfdljfdsfa", seller)}
                        {seller && (
                          <div className="ffd_table mar_bot min_ht_none px-0 table_bor">
                            <BootstrapTable
                              bootstrap4
                              keyField="id"
                              columns={columns}
                              data={seller}
                              pagination={pagination}
                            />
                          </div>
                        )}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* start of shop modal */}
      <Modal
        show={shopModal}
        onHide={handleShopModalClose}
        backdrop="static"
        keyboard={false}
        centered
        className="reg_gender_modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Modal title</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <h5 className="mm_offcanva_ttl">Enter your message</h5>
          <textarea
            id="w3review"
            name="w3review"
            rows="4"
            cols="50"
            className="mt-3"
            style={{ maxWidth: "100%" }}
            value={payupdate?.message}
            onChange={(e)=>{SetPayupdate({...payupdate,...{message:e.target.value}})}}
          ></textarea>
          {
            Error?.message
            ?
            <span className="error-msg">
              {Error?.message}
          </span>
            :
            <></>
          }
          {console.log('messagemessagemessage',payupdate)}
          <div className="mm_canvaclose_modalbtns mt-4">
            <button className="empty_btn" onClick={handleShopModalClose}>
              Cancel
            </button>
            <button
              className="blue_btn mm_saveexitbtn"
              onClick={()=>OrderUpdate()}
            >
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
      {/* end of shop modal */}
    </>
  );
}

export default VendorFinance;
